import { c as _c } from "react/compiler-runtime";
import { Accordion, Button, HStack, Icon, Text } from '@chakra-ui/react';
import { CriticalIssueView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { LuChevronRight, LuTriangleAlert } from 'react-icons/lu';

/** Deck-level "Top Critical Issues" — the highest-weight issues across all slides. */
export function CriticalIssuesList(t0) {
  const $ = _c(9);
  const {
    issues,
    onSelectSlide
  } = t0;
  if (!issues.length) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text color="fg.muted" fontSize="sm">No critical issues flagged — nice work.</Text>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== issues || $[2] !== onSelectSlide) {
    let t2;
    if ($[4] !== issues.length || $[5] !== onSelectSlide) {
      t2 = (issue, idx) => <Accordion.Item key={issue.id} borderBottom={idx === issues.length - 1 ? undefined : "1px solid"} borderBottomColor="colorPalette.panel" value={`critical-${issue.id}`}><Accordion.ItemTrigger borderRadius="none" cursor="pointer"><HStack flex={1} gap={2} paddingY={1}><Icon as={LuTriangleAlert} boxSize={4} color="red.fg" /><Text fontSize="sm" fontWeight="semibold" lineClamp={1} textAlign="left">{issue.ruleTitle || issue.body}</Text></HStack><Accordion.ItemIndicator /></Accordion.ItemTrigger><Accordion.ItemContent><Accordion.ItemBody paddingTop={0}><Text color="fg.muted" fontSize="sm">{issue.body}</Text><Text color="fg.subtle" mt={2} textStyle="label2xs">{issue.slideName}</Text>{issue.pitchDeckSlideId && <Button mt={4} size="xs" variant="cta" onClick={() => onSelectSlide(issue.pitchDeckSlideId as string)}>Go to {issue.classificationLabel || issue.slideName}<LuChevronRight /></Button>}</Accordion.ItemBody></Accordion.ItemContent></Accordion.Item>;
      $[4] = issues.length;
      $[5] = onSelectSlide;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = issues.map(t2);
    $[1] = issues;
    $[2] = onSelectSlide;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <Accordion.Root collapsible={true} multiple={true} bgColor="colorPalette.container" borderRadius="md" variant="enclosed">{t1}</Accordion.Root>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}